// extracted by mini-css-extract-plugin
module.exports = {"cell":"Loader_cell__3NnVZ"};